import classNames from 'classnames'
import Link from '../Link'
import { StencilCDNImage } from '../StencilImage'

const MoreOverlayList = [
  {
    title: 'Insure',
    list: [
      {
        text: 'Life',
        link: '/insurance/term/srp',
        nativeAnchor: true,
        type: '/insurance/term/srp',
        imageUrl: 'https://indcdn.indmoney.com/public/images/Life.png',
      },
      {
        text: 'Health',
        link: '/healthinsurancev2/onboarding',
        nativeAnchor: true,
        type: '/healthinsurancev2/onboarding',
        imageUrl:
          'https://indcdn.indmoney.com/public/images/icon-health-insurance-250523.png',
      },
      {
        text: 'Top-up',
        link: '/insurance/supertopup',
        nativeAnchor: true,
        type: '/insurance/supertopup',
        imageUrl: 'https://indcdn.indmoney.com/public/images/topup.png',
      },
    ],
  },
  {
    title: 'Utilities',
    list: [
      {
        text: 'Calculator',
        link: '/calculators',
        nativeAnchor: false,
        type: '/calculators',
        imageUrl:
          'https://indcdn.indmoney.com/public/images//home_hub_calculator.png',
      },
      {
        text: 'Credit Score',
        link: '/credit-score',
        nativeAnchor: true,
        type: '/credit-score',
        imageUrl:
          'https://indcdn.indmoney.com/public/images/home_hub_credit_score.png',
      },
    ],
  },

  {
    title: 'SIP',
    list: [
      // {
      //   text: 'INDstocks',
      //   link: '/stocks',
      //   nativeAnchor: false,
      //   type: '/stocks',
      //   imageUrl:
      //     'https://indcdn.indmoney.com/public/images/dashboard_drawer/web_investments_widget_images/INStocks_iso@3x.png',
      // },
      {
        text: 'US Stocks',
        link: '/us-stocks/catalogue/top_sips/top_brands',
        nativeAnchor: false,
        type: '/us-stocks/catalogue/top_sips/top_brands',
        imageUrl:
          'https://indcdn.indmoney.com/public/images/home_hub_sip_us_stocks.png',
      },

      {
        text: 'Mutual Funds',
        link: '/investments/mutual-fund/explore-all',
        nativeAnchor: false,
        type: '/investments/mutual-fund/explore-all',
        imageUrl:
          'https://indcdn.indmoney.com/public/images/home_hub_sip_mf.png',
      },
    ],
  },
  {
    title: 'Learn',
    list: [
      {
        text: 'IND Learn',
        link: '/ind-learn',
        nativeAnchor: true,
        type: '/ind-learn',
        imageUrl:
          'https://indcdn.indmoney.com/public/images/home_hub_ind_learn.png',
      },
    ],
  },
  {
    title: 'Help Center',
    list: [
      {
        text: 'My Tickets',
        link: '/help/mytickets',
        nativeAnchor: true,
        type: '/help/mytickets',
        imageUrl:
          'https://indcdn.indmoney.com/public/images/home_hub_my_tickets.png',
      },
      {
        text: 'FAQ’s',
        link: '/help',
        nativeAnchor: true,
        type: '/help',
        imageUrl: 'https://indcdn.indmoney.com/public/images/home_hub_faqs.png',
      },
      {
        text: 'Support',
        link: '/help',
        nativeAnchor: true,
        type: '/help',
        imageUrl:
          'https://indcdn.indmoney.com/public/images/home_hub_support.png',
      },
    ],
  },
]

const MoreMobileOverlay = ({ isOpen, onClose = () => {} }) => {
  return (
    <div>
      {' '}
      <div className="text-34px pr-4 text-right" onClick={onClose}>
        {/* cross html entity */}
        &times;
      </div>
      <div
        className={classNames(
          {
            'invisible opacity-0': !isOpen,
          },
          ' overflow-y-auto px-2 pb-4',
        )}
      >
        <div className="flex flex-col justify-between px-2  ">
          {MoreOverlayList.map((item, idx) => {
            return (
              <div
                className="shadow-one bg-brand-white my-2 flex flex-col rounded-xl px-4 py-5"
                key={idx}
              >
                <div className="mb-2 font-medium">{item.title}</div>{' '}
                <div className="grid grid-cols-3">
                  {item.list.map(subtItem => (
                    <Link
                      key={subtItem.link}
                      href={subtItem.link}
                      aTagClassNames={`text-sm mb-2 hover:text-brand-blue-azureRadiance flex  flex-col items-center `}
                      nativeAnchor={subtItem.nativeAnchor}
                    >
                      <StencilCDNImage
                        width={30}
                        height={30}
                        src={subtItem.imageUrl}
                        alt={`${subtItem.text}`}
                      />
                      <span> {subtItem.text}</span>
                    </Link>
                  ))}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default MoreMobileOverlay
